<div class="empty-free-bet">
    <div class="empty-free-bet-icon" data-crlat="emptyIcon">
        <svg>
            <use xlink:href="#empty-free-bets"></use>
        </svg>
    </div>
    <div class="empty-free-bet-value" [textContent]="message" data-crlat="noFreebets"></div>
</div>
